export const data = [
  //1
  {
    key: "c2-01",
    title: "내 친구는 어디에 있을까?",
    grade: "1권",
    cover: require("@data/assets/orange/book1/images/cover.jpg"),
    background: require("@data/assets/orange/book1/pages/page05.jpg"),
    song: {
      url: require("@data/assets/orange/book1/sounds/page23.mp3"),
      title: "Nǐ hǎo!",
      caption: [
        "친구를 만나면 반갑게 인사해요",
        "nǐ hǎo nǐ hǎo 안녕 nǐ hǎo",
        "선생님을 만나면 공손히 인사해요",
        "nǐ hǎo nǐ hǎo 안녕하세요 nǐ hǎo",
        "친구와 놀고 헤어질때 인사해요",
        "zàijiàn zàijiàn 잘가 zàijiàn",
        "선생님과 공부하고 헤어질때 인사해요",
        "zàijiàn zàijiàn 안녕히 가세요 zàijiàn",
      ],
    },
    mov: {
      cn: "36ec015301b87c4cce57785b5a948d14_01",
      en: "d469bd64293ecf7bb0d6dc1791c69a98_01",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/orange/book1/images/img_O1-03.png"),
          sound: require("@data/assets/orange/book1/sounds/KB01_W_01.mp3"),
          word: "气球|qìqiú",
        },
        {
          img: require("@data/assets/orange/book1/images/img_O1-02.png"),
          sound: require("@data/assets/orange/book1/sounds/KB01_W_02.mp3"),
          word: "蝴蝶|húdié",
        },
        {
          img: require("@data/assets/orange/book1/images/img_O1-01.png"),
          sound: require("@data/assets/orange/book1/sounds/KB01_W_03.mp3"),
          word: "蜜蜂|mìfēng",
        },
        {
          img: require("@data/assets/orange/book1/images/img_O1-06.png"),
          sound: require("@data/assets/orange/book1/sounds/KB01_W_04.mp3"),
          word: "鸟|niǎo",
        },
        {
          img: require("@data/assets/orange/book1/images/img_O1-05.png"),
          sound: require("@data/assets/orange/book1/sounds/KB01_W_05.mp3"),
          word: "水|shuǐ",
        },
        {
          img: require("@data/assets/orange/book1/images/img_O1-04.png"),
          sound: require("@data/assets/orange/book1/sounds/KB01_W_06.mp3"),
          word: "鞋子|xiézi",
        },
        {
          img: require("@data/assets/orange/book1/images/img_O1-08.png"),
          sound: require("@data/assets/orange/book1/sounds/KB01_W_07.mp3"),
          word: "你好!|Nǐ hǎo!",
        },
        {
          img: require("@data/assets/orange/book1/images/img_O1-07.png"),
          sound: require("@data/assets/orange/book1/sounds/KB01_W_08.mp3"),
          word: "再见!|Zàijiàn!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/orange/book1/images/img_O1-03.png"),
        sound: require("@data/assets/orange/book1/sounds/KB01_W_01.mp3"),
        buttons: [{ ch2: "qìqiú" }, { ch: "气球" }, { ko: "풍선" }],
      },
      {
        img: require("@data/assets/orange/book1/images/img_O1-02.png"),
        sound: require("@data/assets/orange/book1/sounds/KB01_W_02.mp3"),
        buttons: [{ ch2: "húdié" }, { ch: "蝴蝶" }, { ko: "나비" }],
      },
      {
        img: require("@data/assets/orange/book1/images/img_O1-01.png"),
        sound: require("@data/assets/orange/book1/sounds/KB01_W_03.mp3"),
        buttons: [{ ch2: "mìfēng" }, { ch: "蜜蜂" }, { ko: "꿀벌" }],
      },
      {
        img: require("@data/assets/orange/book1/images/img_O1-06.png"),
        sound: require("@data/assets/orange/book1/sounds/KB01_W_04.mp3"),
        buttons: [{ ch2: "niǎo" }, { ch: "鸟" }, { ko: "새" }],
      },
      {
        img: require("@data/assets/orange/book1/images/img_O1-05.png"),
        sound: require("@data/assets/orange/book1/sounds/KB01_W_05.mp3"),
        buttons: [{ ch2: "shuǐ" }, { ch: "水" }, { ko: "물" }],
      },
      {
        img: require("@data/assets/orange/book1/images/img_O1-04.png"),
        sound: require("@data/assets/orange/book1/sounds/KB01_W_06.mp3"),
        buttons: [{ ch2: "xiézi" }, { ch: "鞋子" }, { ko: "신발" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/orange/book1/images/img_O1-08.png"),
        sound: require("@data/assets/orange/book1/sounds/KB01_W_07.mp3"),
        buttons: [{ ch2: "Nǐ hǎo!" }, { ch: "你好!" }, { ko: "안녕!" }],
      },
      {
        img: require("@data/assets/orange/book1/images/img_O1-07.png"),
        sound: require("@data/assets/orange/book1/sounds/KB01_W_08.mp3"),
        buttons: [{ ch2: "Zàijiàn!" }, { ch: "再见!" }, { ko: "잘 가!" }],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/orange/book1/sounds/KB01_W_01.mp3"),
          img: require("@data/assets/orange/book1/images/img_O1-02.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/orange/book1/sounds/KB01_W_03.mp3"),
          answer: [
            [require("@data/assets/orange/book1/images/img_O1-06.png"), false],
            [require("@data/assets/orange/book1/images/img_O1-01.png"), true],
          ],
        },
        {
          type: "ty2",
          sound: require("@data/assets/orange/book1/sounds/KB01_W_05.mp3"),
          answer: [
            [require("@data/assets/orange/book1/images/img_O1-05.png"), true],
            [require("@data/assets/orange/book1/images/img_O1-04.png"), false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/orange/book1/pages/front.jpg"),
        sound: require("@data/assets/orange/book1/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/orange/book1/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page04.jpg"),
        sound: require("@data/assets/orange/book1/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page06.jpg"),
        sound: require("@data/assets/orange/book1/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page08.jpg"),
        sound: require("@data/assets/orange/book1/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page10.jpg"),
        sound: require("@data/assets/orange/book1/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page12.jpg"),
        sound: require("@data/assets/orange/book1/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page14.jpg"),
        sound: require("@data/assets/orange/book1/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page16.jpg"),
        sound: require("@data/assets/orange/book1/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page18.jpg"),
        sound: require("@data/assets/orange/book1/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page20.jpg"),
        sound: require("@data/assets/orange/book1/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page22.jpg"),
        sound: require("@data/assets/orange/book1/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page23.jpg"),
        sound: require("@data/assets/orange/book1/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/orange/book1/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/orange/book1/thumbnail/front.jpg"),
      require("@data/assets/orange/book1/thumbnail/page02.jpg"),
      require("@data/assets/orange/book1/thumbnail/page03.jpg"),
      require("@data/assets/orange/book1/thumbnail/page04.jpg"),
      require("@data/assets/orange/book1/thumbnail/page05.jpg"),
      require("@data/assets/orange/book1/thumbnail/page06.jpg"),
      require("@data/assets/orange/book1/thumbnail/page07.jpg"),
      require("@data/assets/orange/book1/thumbnail/page08.jpg"),
      require("@data/assets/orange/book1/thumbnail/page09.jpg"),
      require("@data/assets/orange/book1/thumbnail/page10.jpg"),
      require("@data/assets/orange/book1/thumbnail/page11.jpg"),
      require("@data/assets/orange/book1/thumbnail/page12.jpg"),
      require("@data/assets/orange/book1/thumbnail/page13.jpg"),
      require("@data/assets/orange/book1/thumbnail/page14.jpg"),
      require("@data/assets/orange/book1/thumbnail/page15.jpg"),
      require("@data/assets/orange/book1/thumbnail/page16.jpg"),
      require("@data/assets/orange/book1/thumbnail/page17.jpg"),
      require("@data/assets/orange/book1/thumbnail/page18.jpg"),
      require("@data/assets/orange/book1/thumbnail/page19.jpg"),
      require("@data/assets/orange/book1/thumbnail/page20.jpg"),
      require("@data/assets/orange/book1/thumbnail/page21.jpg"),
      require("@data/assets/orange/book1/thumbnail/page22.jpg"),
      require("@data/assets/orange/book1/thumbnail/page23.jpg"),
      require("@data/assets/orange/book1/thumbnail/page24.jpg"),
      require("@data/assets/orange/book1/thumbnail/page25.jpg"),
      require("@data/assets/orange/book1/thumbnail/page26.jpg"),
      require("@data/assets/orange/book1/thumbnail/page27.jpg"),
    ],
  },
  //2
  {
    key: "c2-02",
    title: "쑥쑥 자라요",
    grade: "2권",
    cover: require("@data/assets/orange/book2/images/cover.jpg"),
    background: require("@data/assets/orange/book2/pages/page05.jpg"),
    song: {
      url: require("@data/assets/orange/book2/sounds/page23.mp3"),
      title: "Zǎoshang hǎo!",
      caption: [
        "아침이 밝았어요 안녕 zǎoshang hǎo 안녕 zǎoshang hǎo",
        "랄라랄라 신나는 하루를 시작해요 안녕 zǎoshang hǎo",
        "밤이 깊었어요 잘자 wǎn’ān 새근새근 이제는 자야할 시간이에요",
        "잘자 wǎn’ān 잘자 wǎn’ān",
      ],
    },
    mov: {
      cn: "10c720978d9a87a0476844ce76ad2400_02",
      en: "398f957068042cb8663d8001c12faf32_02",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/orange/book2/images/img_O2-03.png"),
          sound: require("@data/assets/orange/book2/sounds/KB02_W_01.mp3"),
          word: "鱼|yú",
        },
        {
          img: require("@data/assets/orange/book2/images/img_O2-02.png"),
          sound: require("@data/assets/orange/book2/sounds/KB02_W_02.mp3"),
          word: "石头|shítou",
        },
        {
          img: require("@data/assets/orange/book2/images/img_O2-01.png"),
          sound: require("@data/assets/orange/book2/sounds/KB02_W_03.mp3"),
          word: "蝌蚪|kēdǒu",
        },
        {
          img: require("@data/assets/orange/book2/images/img_O2-06.png"),
          sound: require("@data/assets/orange/book2/sounds/KB02_W_04.mp3"),
          word: "镜子|jìngzi",
        },
        {
          img: require("@data/assets/orange/book2/images/img_O2-05.png"),
          sound: require("@data/assets/orange/book2/sounds/KB02_W_05.mp3"),
          word: "钢琴|gāngqín",
        },
        {
          img: require("@data/assets/orange/book2/images/img_O2-04.png"),
          sound: require("@data/assets/orange/book2/sounds/KB02_W_06.mp3"),
          word: "照片|zhàopiàn",
        },
        {
          img: require("@data/assets/orange/book2/images/img_O2-08.png"),
          sound: require("@data/assets/orange/book2/sounds/KB02_W_07.mp3"),
          word: "早上好!|Zǎoshang hǎo!",
        },
        {
          img: require("@data/assets/orange/book2/images/img_O2-07.png"),
          sound: require("@data/assets/orange/book2/sounds/KB02_W_08.mp3"),
          word: "晚安!|Wǎn'ān!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/orange/book2/images/img_O2-03.png"),
        sound: require("@data/assets/orange/book2/sounds/KB02_W_01.mp3"),
        buttons: [{ ch2: "yú" }, { ch: "鱼" }, { ko: "물고기" }],
      },
      {
        img: require("@data/assets/orange/book2/images/img_O2-02.png"),
        sound: require("@data/assets/orange/book2/sounds/KB02_W_02.mp3"),
        buttons: [{ ch2: "shítou" }, { ch: "石头" }, { ko: "돌" }],
      },
      {
        img: require("@data/assets/orange/book2/images/img_O2-01.png"),
        sound: require("@data/assets/orange/book2/sounds/KB02_W_03.mp3"),
        buttons: [{ ch2: "kēdǒu" }, { ch: "蝌蚪" }, { ko: "올챙이" }],
      },
      {
        img: require("@data/assets/orange/book2/images/img_O2-06.png"),
        sound: require("@data/assets/orange/book2/sounds/KB02_W_04.mp3"),
        buttons: [{ ch2: "jìngzi" }, { ch: "镜子" }, { ko: "거울" }],
      },
      {
        img: require("@data/assets/orange/book2/images/img_O2-05.png"),
        sound: require("@data/assets/orange/book2/sounds/KB02_W_05.mp3"),
        buttons: [{ ch2: "gāngqín" }, { ch: "钢琴" }, { ko: "피아노" }],
      },
      {
        img: require("@data/assets/orange/book2/images/img_O2-04.png"),
        sound: require("@data/assets/orange/book2/sounds/KB02_W_06.mp3"),
        buttons: [{ ch2: "zhàopiàn" }, { ch: "照片" }, { ko: "사진" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/orange/book2/images/img_O2-08.png"),
        sound: require("@data/assets/orange/book2/sounds/KB02_W_07.mp3"),
        buttons: [
          { ch2: "Zǎoshang hǎo!" },
          { ch: "早上好!" },
          { ko: "좋은 아침이에요!" },
        ],
      },
      {
        img: require("@data/assets/orange/book2/images/img_O2-07.png"),
        sound: require("@data/assets/orange/book2/sounds/KB02_W_08.mp3"),
        buttons: [{ ch2: "Wǎn'ān!" }, { ch: "晚安!" }, { ko: "잘 자요!" }],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/orange/book2/sounds/KB02_W_02.mp3"),
          img: require("@data/assets/orange/book2/images/img_O2-02.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/orange/book2/sounds/KB02_W_04.mp3"),
          answer: [
            [require("@data/assets/orange/book2/images/img_O2-01.png"), false],
            [require("@data/assets/orange/book2/images/img_O2-06.png"), true],
          ],
        },
        {
          type: "ty2",
          sound: require("@data/assets/orange/book2/sounds/KB02_W_05.mp3"),
          answer: [
            [require("@data/assets/orange/book2/images/img_O2-03.png"), false],
            [require("@data/assets/orange/book2/images/img_O2-05.png"), true],
          ],
        },
      ],
    },

    pages: [
      {
        book: require("@data/assets/orange/book2/pages/front.jpg"),
        sound: require("@data/assets/orange/book2/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/orange/book2/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page04.jpg"),
        sound: require("@data/assets/orange/book2/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page06.jpg"),
        sound: require("@data/assets/orange/book2/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page08.jpg"),
        sound: require("@data/assets/orange/book2/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page10.jpg"),
        sound: require("@data/assets/orange/book2/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page12.jpg"),
        sound: require("@data/assets/orange/book2/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page14.jpg"),
        sound: require("@data/assets/orange/book2/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page16.jpg"),
        sound: require("@data/assets/orange/book2/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page18.jpg"),
        sound: require("@data/assets/orange/book2/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page20.jpg"),
        sound: require("@data/assets/orange/book2/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page22.jpg"),
        sound: require("@data/assets/orange/book2/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page23.jpg"),
        sound: require("@data/assets/orange/book2/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/orange/book2/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/orange/book2/thumbnail/front.jpg"),
      require("@data/assets/orange/book2/thumbnail/page02.jpg"),
      require("@data/assets/orange/book2/thumbnail/page03.jpg"),
      require("@data/assets/orange/book2/thumbnail/page04.jpg"),
      require("@data/assets/orange/book2/thumbnail/page05.jpg"),
      require("@data/assets/orange/book2/thumbnail/page06.jpg"),
      require("@data/assets/orange/book2/thumbnail/page07.jpg"),
      require("@data/assets/orange/book2/thumbnail/page08.jpg"),
      require("@data/assets/orange/book2/thumbnail/page09.jpg"),
      require("@data/assets/orange/book2/thumbnail/page10.jpg"),
      require("@data/assets/orange/book2/thumbnail/page11.jpg"),
      require("@data/assets/orange/book2/thumbnail/page12.jpg"),
      require("@data/assets/orange/book2/thumbnail/page13.jpg"),
      require("@data/assets/orange/book2/thumbnail/page14.jpg"),
      require("@data/assets/orange/book2/thumbnail/page15.jpg"),
      require("@data/assets/orange/book2/thumbnail/page16.jpg"),
      require("@data/assets/orange/book2/thumbnail/page17.jpg"),
      require("@data/assets/orange/book2/thumbnail/page18.jpg"),
      require("@data/assets/orange/book2/thumbnail/page19.jpg"),
      require("@data/assets/orange/book2/thumbnail/page20.jpg"),
      require("@data/assets/orange/book2/thumbnail/page21.jpg"),
      require("@data/assets/orange/book2/thumbnail/page22.jpg"),
      require("@data/assets/orange/book2/thumbnail/page23.jpg"),
      require("@data/assets/orange/book2/thumbnail/page24.jpg"),
      require("@data/assets/orange/book2/thumbnail/page25.jpg"),
      require("@data/assets/orange/book2/thumbnail/page26.jpg"),
      require("@data/assets/orange/book2/thumbnail/page27.jpg"),
    ],
  },
  //3
  {
    key: "c2-03",
    title: "으스스한 이웃",
    grade: "3권",
    cover: require("@data/assets/orange/book3/images/cover.jpg"),
    background: require("@data/assets/orange/book3/pages/page05.jpg"),
    song: {
      url: require("@data/assets/orange/book3/sounds/page23.mp3"),
      title: "Xièxie!",
      caption: [
        "고마워 고마워 xièxie xièxie 도와줘서 고마워",
        "아니야 아니야  bú kèqi  bú kèqi 우린 좋은 친구니까",
        "xièxie  xièxie  방긋 웃으며 고맙다고 말해요",
        "xièxie  bú kèqi 고마운 마음 주고 받아요  ",
        "고마워 고마워 xièxie xièxie 예쁜 선물 고마워",
        "아니야 아니야  bú kèqi  bú kèqi 우린 좋은 친구니까",
        "xièxie  xièxie  방긋 웃으며 고맙다고 말해요",
        "xièxie  bú kèqi 고마운 마음 주고 받아요",
      ],
    },
    mov: {
      cn: "2074464b2c751d3e6c7d3e6d622a520d_03",
      en: "8ac9a7e1b45c20fa75e03d8f81554838_03",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/orange/book3/images/img_O3-03.png"),
          sound: require("@data/assets/orange/book3/sounds/KB03_W_01.mp3"),
          word: "窗户|chuānghu",
        },
        {
          img: require("@data/assets/orange/book3/images/img_O3-02.png"),
          sound: require("@data/assets/orange/book3/sounds/KB03_W_02.mp3"),
          word: "眼镜|yǎnjìng",
        },
        {
          img: require("@data/assets/orange/book3/images/img_O3-01.png"),
          sound: require("@data/assets/orange/book3/sounds/KB03_W_03.mp3"),
          word: "门|mén",
        },
        {
          img: require("@data/assets/orange/book3/images/img_O3-06.png"),
          sound: require("@data/assets/orange/book3/sounds/KB03_W_04.mp3"),
          word: "玩具|wánjù",
        },
        {
          img: require("@data/assets/orange/book3/images/img_O3-05.png"),
          sound: require("@data/assets/orange/book3/sounds/KB03_W_05.mp3"),
          word: "沙发|shāfā",
        },
        {
          img: require("@data/assets/orange/book3/images/img_O3-04.png"),
          sound: require("@data/assets/orange/book3/sounds/KB03_W_06.mp3"),
          word: "冰箱|bīngxiāng",
        },
        {
          img: require("@data/assets/orange/book3/images/img_O3-07.png"),
          sound: require("@data/assets/orange/book3/sounds/KB03_W_07.mp3"),
          word: "谢谢!|Xièxie!",
        },
        {
          img: require("@data/assets/orange/book3/images/img_O3-08.png"),
          sound: require("@data/assets/orange/book3/sounds/KB03_W_08.mp3"),
          word: "不客气!|Bú kèqi!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/orange/book3/images/img_O3-03.png"),
        sound: require("@data/assets/orange/book3/sounds/KB03_W_01.mp3"),
        buttons: [{ ch2: "chuānghu" }, { ch: "窗户" }, { ko: "창문" }],
      },
      {
        img: require("@data/assets/orange/book3/images/img_O3-02.png"),
        sound: require("@data/assets/orange/book3/sounds/KB03_W_02.mp3"),
        buttons: [{ ch2: "yǎnjìng" }, { ch: "眼镜" }, { ko: "안경" }],
      },
      {
        img: require("@data/assets/orange/book3/images/img_O3-01.png"),
        sound: require("@data/assets/orange/book3/sounds/KB03_W_03.mp3"),
        buttons: [{ ch2: "mén" }, { ch: "门" }, { ko: "문" }],
      },
      {
        img: require("@data/assets/orange/book3/images/img_O3-06.png"),
        sound: require("@data/assets/orange/book3/sounds/KB03_W_04.mp3"),
        buttons: [{ ch2: "wánjù" }, { ch: "玩具" }, { ko: "장난감" }],
      },
      {
        img: require("@data/assets/orange/book3/images/img_O3-05.png"),
        sound: require("@data/assets/orange/book3/sounds/KB03_W_05.mp3"),
        buttons: [{ ch2: "shāfā" }, { ch: "沙发" }, { ko: "소파" }],
      },
      {
        img: require("@data/assets/orange/book3/images/img_O3-04.png"),
        sound: require("@data/assets/orange/book3/sounds/KB03_W_06.mp3"),
        buttons: [{ ch2: "bīngxiāng" }, { ch: "冰箱" }, { ko: "냉장고" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/orange/book3/images/img_O3-07.png"),
        sound: require("@data/assets/orange/book3/sounds/KB03_W_07.mp3"),
        buttons: [{ ch2: "Xièxie!" }, { ch: "谢谢!" }, { ko: "고마워!" }],
      },
      {
        img: require("@data/assets/orange/book3/images/img_O3-08.png"),
        sound: require("@data/assets/orange/book3/sounds/KB03_W_08.mp3"),
        buttons: [{ ch2: "Bú kèqi!" }, { ch: "不客气!" }, { ko: "천만에!" }],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/orange/book3/sounds/KB03_W_01.mp3"),
          img: require("@data/assets/orange/book3/images/img_O3-02.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/orange/book3/sounds/KB03_W_04.mp3"),
          answer: [
            [require("@data/assets/orange/book3/images/img_O3-06.png"), true],
            [require("@data/assets/orange/book3/images/img_O3-05.png"), false],
          ],
        },
        {
          type: "ty2",
          sound: require("@data/assets/orange/book3/sounds/KB03_W_03.mp3"),
          answer: [
            [require("@data/assets/orange/book3/images/img_O3-01.png"), true],
            [require("@data/assets/orange/book3/images/img_O3-04.png"), false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/orange/book3/pages/front.jpg"),
        sound: require("@data/assets/orange/book3/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/orange/book3/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page04.jpg"),
        sound: require("@data/assets/orange/book3/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page06.jpg"),
        sound: require("@data/assets/orange/book3/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page08.jpg"),
        sound: require("@data/assets/orange/book3/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page10.jpg"),
        sound: require("@data/assets/orange/book3/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page12.jpg"),
        sound: require("@data/assets/orange/book3/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page14.jpg"),
        sound: require("@data/assets/orange/book3/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page16.jpg"),
        sound: require("@data/assets/orange/book3/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page18.jpg"),
        sound: require("@data/assets/orange/book3/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page20.jpg"),
        sound: require("@data/assets/orange/book3/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page22.jpg"),
        sound: require("@data/assets/orange/book3/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page23.jpg"),
        sound: require("@data/assets/orange/book3/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/orange/book3/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/orange/book3/thumbnail/front.jpg"),
      require("@data/assets/orange/book3/thumbnail/page02.jpg"),
      require("@data/assets/orange/book3/thumbnail/page03.jpg"),
      require("@data/assets/orange/book3/thumbnail/page04.jpg"),
      require("@data/assets/orange/book3/thumbnail/page05.jpg"),
      require("@data/assets/orange/book3/thumbnail/page06.jpg"),
      require("@data/assets/orange/book3/thumbnail/page07.jpg"),
      require("@data/assets/orange/book3/thumbnail/page08.jpg"),
      require("@data/assets/orange/book3/thumbnail/page09.jpg"),
      require("@data/assets/orange/book3/thumbnail/page10.jpg"),
      require("@data/assets/orange/book3/thumbnail/page11.jpg"),
      require("@data/assets/orange/book3/thumbnail/page12.jpg"),
      require("@data/assets/orange/book3/thumbnail/page13.jpg"),
      require("@data/assets/orange/book3/thumbnail/page14.jpg"),
      require("@data/assets/orange/book3/thumbnail/page15.jpg"),
      require("@data/assets/orange/book3/thumbnail/page16.jpg"),
      require("@data/assets/orange/book3/thumbnail/page17.jpg"),
      require("@data/assets/orange/book3/thumbnail/page18.jpg"),
      require("@data/assets/orange/book3/thumbnail/page19.jpg"),
      require("@data/assets/orange/book3/thumbnail/page20.jpg"),
      require("@data/assets/orange/book3/thumbnail/page21.jpg"),
      require("@data/assets/orange/book3/thumbnail/page22.jpg"),
      require("@data/assets/orange/book3/thumbnail/page23.jpg"),
      require("@data/assets/orange/book3/thumbnail/page24.jpg"),
      require("@data/assets/orange/book3/thumbnail/page25.jpg"),
      require("@data/assets/orange/book3/thumbnail/page26.jpg"),
      require("@data/assets/orange/book3/thumbnail/page27.jpg"),
    ],
  },
  //4
  {
    key: "c2-04",
    title: "우리는 친구",
    grade: "4권",
    cover: require("@data/assets/orange/book4/images/cover.jpg"),
    background: require("@data/assets/orange/book4/pages/page05.jpg"),
    song: {
      url: require("@data/assets/orange/book4/sounds/page23.mp3"),
      title: "Duìbuqǐ!",
      caption: [
        "친구한테 미안할 땐 용기내어 사과해요",
        "미안해 duìbuqǐ  미안해  duìbuqǐ",
        "친구가 사과하면 웃으며 말해요",
        "괜찮아 méi guānxi 괜찮아  méi guānxi",
        "친구와 싸우지말고 서로 서로 화해해요",
        "미안해 duìbuqǐ 미안해 duìbuqǐ",
        "우리는 친구니까 미소 지으며 말해요",
        "괜찮아 méi guānxi 괜찮아 méi guānxi",
        "미안해 duìbuqǐ 괜찮아 méi guānxi",
        "미안해 duìbuqǐ 괜찮아 méi guānxi",
      ],
    },
    mov: {
      cn: "e90fb3854221fba35277a10e74e16951_04",
      en: "e7be08aee6492150c81a70d8b6676c4d_04",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/orange/book4/images/img_O4-03.png"),
          sound: require("@data/assets/orange/book4/sounds/KB04_W_01.mp3"),
          word: "桌子|zhuōzi",
        },
        {
          img: require("@data/assets/orange/book4/images/img_O4-02.png"),
          sound: require("@data/assets/orange/book4/sounds/KB04_W_02.mp3"),
          word: "牛奶|niúnǎi",
        },
        {
          img: require("@data/assets/orange/book4/images/img_O4-01.png"),
          sound: require("@data/assets/orange/book4/sounds/KB04_W_03.mp3"),
          word: "花|huā",
        },
        {
          img: require("@data/assets/orange/book4/images/img_O4-06.png"),
          sound: require("@data/assets/orange/book4/sounds/KB04_W_04.mp3"),
          word: "书|shū",
        },
        {
          img: require("@data/assets/orange/book4/images/img_O4-05.png"),
          sound: require("@data/assets/orange/book4/sounds/KB04_W_05.mp3"),
          word: "滑梯|huátī",
        },
        {
          img: require("@data/assets/orange/book4/images/img_O4-04.png"),
          sound: require("@data/assets/orange/book4/sounds/KB04_W_06.mp3"),
          word: "头|tóu",
        },
        {
          img: require("@data/assets/orange/book4/images/img_O4-08.png"),
          sound: require("@data/assets/orange/book4/sounds/KB04_W_07.mp3"),
          word: "对不起!|Duìbuqǐ!",
        },
        {
          img: require("@data/assets/orange/book4/images/img_O4-07.png"),
          sound: require("@data/assets/orange/book4/sounds/KB04_W_08.mp3"),
          word: "没关系!|Méi guānxi",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/orange/book4/images/img_O4-03.png"),
        sound: require("@data/assets/orange/book4/sounds/KB04_W_01.mp3"),
        buttons: [{ ch2: "zhuōzi" }, { ch: "桌子" }, { ko: "책상" }],
      },
      {
        img: require("@data/assets/orange/book4/images/img_O4-02.png"),
        sound: require("@data/assets/orange/book4/sounds/KB04_W_02.mp3"),
        buttons: [{ ch2: "niúnǎi" }, { ch: "牛奶" }, { ko: "우유" }],
      },
      {
        img: require("@data/assets/orange/book4/images/img_O4-01.png"),
        sound: require("@data/assets/orange/book4/sounds/KB04_W_03.mp3"),
        buttons: [{ ch2: "huā" }, { ch: "花" }, { ko: "꽃" }],
      },
      {
        img: require("@data/assets/orange/book4/images/img_O4-06.png"),
        sound: require("@data/assets/orange/book4/sounds/KB04_W_04.mp3"),
        buttons: [{ ch2: "shū" }, { ch: "书" }, { ko: "책" }],
      },
      {
        img: require("@data/assets/orange/book4/images/img_O4-05.png"),
        sound: require("@data/assets/orange/book4/sounds/KB04_W_05.mp3"),
        buttons: [{ ch2: "huátī" }, { ch: "滑梯" }, { ko: "미끄럼틀" }],
      },
      {
        img: require("@data/assets/orange/book4/images/img_O4-04.png"),
        sound: require("@data/assets/orange/book4/sounds/KB04_W_06.mp3"),
        buttons: [{ ch2: "tóu" }, { ch: "头" }, { ko: "머리" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/orange/book4/images/img_O4-08.png"),
        sound: require("@data/assets/orange/book4/sounds/KB04_W_07.mp3"),
        buttons: [{ ch2: "Duìbuqǐ!" }, { ch: "对不起!" }, { ko: "미안해!" }],
      },
      {
        img: require("@data/assets/orange/book4/images/img_O4-07.png"),
        sound: require("@data/assets/orange/book4/sounds/KB04_W_08.mp3"),
        buttons: [{ ch2: "Méi guānxi!" }, { ch: "没关系!" }, { ko: "괜찮아!" }],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/orange/book4/sounds/KB04_W_02.mp3"),
          img: require("@data/assets/orange/book4/images/img_O4-02.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/orange/book4/sounds/KB04_W_04.mp3"),
          answer: [
            [require("@data/assets/orange/book4/images/img_O4-01.png"), false],
            [require("@data/assets/orange/book4/images/img_O4-06.png"), true],
          ],
        },
        {
          type: "ty2",
          sound: require("@data/assets/orange/book4/sounds/KB04_W_05.mp3"),
          answer: [
            [require("@data/assets/orange/book4/images/img_O4-05.png"), true],
            [require("@data/assets/orange/book4/images/img_O4-03.png"), false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/orange/book4/pages/front.jpg"),
        sound: require("@data/assets/orange/book4/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/orange/book4/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page04.jpg"),
        sound: require("@data/assets/orange/book4/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page06.jpg"),
        sound: require("@data/assets/orange/book4/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page08.jpg"),
        sound: require("@data/assets/orange/book4/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page10.jpg"),
        sound: require("@data/assets/orange/book4/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page12.jpg"),
        sound: require("@data/assets/orange/book4/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page14.jpg"),
        sound: require("@data/assets/orange/book4/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page16.jpg"),
        sound: require("@data/assets/orange/book4/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page18.jpg"),
        sound: require("@data/assets/orange/book4/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page20.jpg"),
        sound: require("@data/assets/orange/book4/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page22.jpg"),
        sound: require("@data/assets/orange/book4/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page23.jpg"),
        sound: require("@data/assets/orange/book4/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/orange/book4/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/orange/book4/thumbnail/front.jpg"),
      require("@data/assets/orange/book4/thumbnail/page02.jpg"),
      require("@data/assets/orange/book4/thumbnail/page03.jpg"),
      require("@data/assets/orange/book4/thumbnail/page04.jpg"),
      require("@data/assets/orange/book4/thumbnail/page05.jpg"),
      require("@data/assets/orange/book4/thumbnail/page06.jpg"),
      require("@data/assets/orange/book4/thumbnail/page07.jpg"),
      require("@data/assets/orange/book4/thumbnail/page08.jpg"),
      require("@data/assets/orange/book4/thumbnail/page09.jpg"),
      require("@data/assets/orange/book4/thumbnail/page10.jpg"),
      require("@data/assets/orange/book4/thumbnail/page11.jpg"),
      require("@data/assets/orange/book4/thumbnail/page12.jpg"),
      require("@data/assets/orange/book4/thumbnail/page13.jpg"),
      require("@data/assets/orange/book4/thumbnail/page14.jpg"),
      require("@data/assets/orange/book4/thumbnail/page15.jpg"),
      require("@data/assets/orange/book4/thumbnail/page16.jpg"),
      require("@data/assets/orange/book4/thumbnail/page17.jpg"),
      require("@data/assets/orange/book4/thumbnail/page18.jpg"),
      require("@data/assets/orange/book4/thumbnail/page19.jpg"),
      require("@data/assets/orange/book4/thumbnail/page20.jpg"),
      require("@data/assets/orange/book4/thumbnail/page21.jpg"),
      require("@data/assets/orange/book4/thumbnail/page22.jpg"),
      require("@data/assets/orange/book4/thumbnail/page23.jpg"),
      require("@data/assets/orange/book4/thumbnail/page24.jpg"),
      require("@data/assets/orange/book4/thumbnail/page25.jpg"),
      require("@data/assets/orange/book4/thumbnail/page26.jpg"),
      require("@data/assets/orange/book4/thumbnail/page27.jpg"),
    ],
  },
  //5
  {
    key: "c2-05",
    title: "신비한 마법 요리",
    grade: "5권",
    cover: require("@data/assets/orange/book5/images/cover.jpg"),
    background: require("@data/assets/orange/book5/pages/page05.jpg"),
    song: {
      url: require("@data/assets/orange/book5/sounds/page23.mp3"),
      title: "Hěn hǎochī!",
      caption: [
        "갓 구워 고소하고 맛있는 빵 입안에서 살살 녹는 아이스크림",
        "친구와 사이좋게 나눠먹어요 맛있어  hěn hǎochī  hěn hǎochī",
        "아무도 안 주고 혼자 먹어요 맛없어 bù hǎochī  bù hǎochī",
        "갓 구워 고소하고 맛있는 빵 입안에서 살살 녹는 아이스크림",
        "친구 한 개 나 한 개 나눠먹어요 맛있어  hěn hǎochī  hěn hǎochī",
        "사이 좋게 둘러 앉아먹어요 맛있어  hěn hǎochī  hěn hǎochī",
      ],
    },
    mov: {
      cn: "060f51c33f5bdc172a78ab515fa49248_05",
      en: "7d662475a515fdc910b24575e0e1af8f_05",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/orange/book5/images/img_O5-03.png"),
          sound: require("@data/assets/orange/book5/sounds/KB05_W_01.mp3"),
          word: "床|chuáng",
        },
        {
          img: require("@data/assets/orange/book5/images/img_O5-02.png"),
          sound: require("@data/assets/orange/book5/sounds/KB05_W_02.mp3"),
          word: "衣服|yīfu",
        },
        {
          img: require("@data/assets/orange/book5/images/img_O5-01.png"),
          sound: require("@data/assets/orange/book5/sounds/KB05_W_03.mp3"),
          word: "厨师|chúshī",
        },
        {
          img: require("@data/assets/orange/book5/images/img_O5-06.png"),
          sound: require("@data/assets/orange/book5/sounds/KB05_W_04.mp3"),
          word: "胡萝卜|húluóbo",
        },
        {
          img: require("@data/assets/orange/book5/images/img_O5-05.png"),
          sound: require("@data/assets/orange/book5/sounds/KB05_W_05.mp3"),
          word: "红薯|hóngshǔ",
        },
        {
          img: require("@data/assets/orange/book5/images/img_O5-04.png"),
          sound: require("@data/assets/orange/book5/sounds/KB05_W_06.mp3"),
          word: "厨房|chúfáng",
        },
        {
          img: require("@data/assets/orange/book5/images/img_O5-08.png"),
          sound: require("@data/assets/orange/book5/sounds/KB05_W_07.mp3"),
          word: "很好吃！|Hěn hǎochī!",
        },
        {
          img: require("@data/assets/orange/book5/images/img_O5-07.png"),
          sound: require("@data/assets/orange/book5/sounds/KB05_W_08.mp3"),
          word: "不好吃！|Bù hǎochī!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/orange/book5/images/img_O5-03.png"),
        sound: require("@data/assets/orange/book5/sounds/KB05_W_01.mp3"),
        buttons: [{ ch2: "chuáng" }, { ch: "床" }, { ko: "침대" }],
      },
      {
        img: require("@data/assets/orange/book5/images/img_O5-02.png"),
        sound: require("@data/assets/orange/book5/sounds/KB05_W_02.mp3"),
        buttons: [{ ch2: "yīfu" }, { ch: "衣服" }, { ko: "옷" }],
      },
      {
        img: require("@data/assets/orange/book5/images/img_O5-01.png"),
        sound: require("@data/assets/orange/book5/sounds/KB05_W_03.mp3"),
        buttons: [{ ch2: "chúshī" }, { ch: "厨师" }, { ko: "요리사" }],
      },
      {
        img: require("@data/assets/orange/book5/images/img_O5-06.png"),
        sound: require("@data/assets/orange/book5/sounds/KB05_W_04.mp3"),
        buttons: [{ ch2: "húluóbo" }, { ch: "胡萝卜" }, { ko: "당근" }],
      },
      {
        img: require("@data/assets/orange/book5/images/img_O5-05.png"),
        sound: require("@data/assets/orange/book5/sounds/KB05_W_05.mp3"),
        buttons: [{ ch2: "hóngshǔ" }, { ch: "红薯" }, { ko: "고구마" }],
      },
      {
        img: require("@data/assets/orange/book5/images/img_O5-04.png"),
        sound: require("@data/assets/orange/book5/sounds/KB05_W_06.mp3"),
        buttons: [{ ch2: "chúfáng" }, { ch: "厨房" }, { ko: "부엌, 주방" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/orange/book5/images/img_O5-08.png"),
        sound: require("@data/assets/orange/book5/sounds/KB05_W_07.mp3"),
        buttons: [
          { ch2: "Hěn hǎochī!" },
          { ch: "很好吃！" },
          { ko: "맛있어!" },
        ],
      },
      {
        img: require("@data/assets/orange/book5/images/img_O5-07.png"),
        sound: require("@data/assets/orange/book5/sounds/KB05_W_08.mp3"),
        buttons: [{ ch2: "Bù hǎochī!" }, { ch: "不好吃！" }, { ko: "맛없어!" }],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/orange/book5/sounds/KB05_W_02.mp3"),
          img: require("@data/assets/orange/book5/images/img_O5-03.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/orange/book5/sounds/KB05_W_03.mp3"),
          answer: [
            [require("@data/assets/orange/book5/images/img_O5-01.png"), true],
            [require("@data/assets/orange/book5/images/img_O5-05.png"), false],
          ],
        },
        {
          type: "ty2",
          sound: require("@data/assets/orange/book5/sounds/KB05_W_04.mp3"),
          answer: [
            [require("@data/assets/orange/book5/images/img_O5-04.png"), false],
            [require("@data/assets/orange/book5/images/img_O5-06.png"), true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/orange/book5/pages/front.jpg"),
        sound: require("@data/assets/orange/book5/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/orange/book5/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page04.jpg"),
        sound: require("@data/assets/orange/book5/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page06.jpg"),
        sound: require("@data/assets/orange/book5/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page08.jpg"),
        sound: require("@data/assets/orange/book5/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page10.jpg"),
        sound: require("@data/assets/orange/book5/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page12.jpg"),
        sound: require("@data/assets/orange/book5/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page14.jpg"),
        sound: require("@data/assets/orange/book5/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page16.jpg"),
        sound: require("@data/assets/orange/book5/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page18.jpg"),
        sound: require("@data/assets/orange/book5/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page20.jpg"),
        sound: require("@data/assets/orange/book5/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page22.jpg"),
        sound: require("@data/assets/orange/book5/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page23.jpg"),
        sound: require("@data/assets/orange/book5/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/orange/book5/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/orange/book5/thumbnail/front.jpg"),
      require("@data/assets/orange/book5/thumbnail/page02.jpg"),
      require("@data/assets/orange/book5/thumbnail/page03.jpg"),
      require("@data/assets/orange/book5/thumbnail/page04.jpg"),
      require("@data/assets/orange/book5/thumbnail/page05.jpg"),
      require("@data/assets/orange/book5/thumbnail/page06.jpg"),
      require("@data/assets/orange/book5/thumbnail/page07.jpg"),
      require("@data/assets/orange/book5/thumbnail/page08.jpg"),
      require("@data/assets/orange/book5/thumbnail/page09.jpg"),
      require("@data/assets/orange/book5/thumbnail/page10.jpg"),
      require("@data/assets/orange/book5/thumbnail/page11.jpg"),
      require("@data/assets/orange/book5/thumbnail/page12.jpg"),
      require("@data/assets/orange/book5/thumbnail/page13.jpg"),
      require("@data/assets/orange/book5/thumbnail/page14.jpg"),
      require("@data/assets/orange/book5/thumbnail/page15.jpg"),
      require("@data/assets/orange/book5/thumbnail/page16.jpg"),
      require("@data/assets/orange/book5/thumbnail/page17.jpg"),
      require("@data/assets/orange/book5/thumbnail/page18.jpg"),
      require("@data/assets/orange/book5/thumbnail/page19.jpg"),
      require("@data/assets/orange/book5/thumbnail/page20.jpg"),
      require("@data/assets/orange/book5/thumbnail/page21.jpg"),
      require("@data/assets/orange/book5/thumbnail/page22.jpg"),
      require("@data/assets/orange/book5/thumbnail/page23.jpg"),
      require("@data/assets/orange/book5/thumbnail/page24.jpg"),
      require("@data/assets/orange/book5/thumbnail/page25.jpg"),
      require("@data/assets/orange/book5/thumbnail/page26.jpg"),
      require("@data/assets/orange/book5/thumbnail/page27.jpg"),
    ],
  },
  //6
  {
    key: "c2-06",
    title: "사이좋게 놀아요",
    grade: "6권",
    cover: require("@data/assets/orange/book6/images/cover.jpg"),
    background: require("@data/assets/orange/book6/pages/page05.jpg"),
    song: {
      url: require("@data/assets/orange/book6/sounds/page23.mp3"),
      title: "Hěn yǒu yìsi!",
      caption: [
        "친구와 오순도순 사이좋게 놀아요 하하하 재미있어 hěn yǒu yìsi",
        "언제나 우리들은 사이좋게 놀아요 랄랄라 재미있어 hěn yǒu yìsi",
        "혼자서 삐죽삐죽 투덜투덜 거려요 심심해 재미없어 méiyǒu yìsi",
        "지루해 재미없어 méiyǒu yìsi  이제는 친구와 사이좋게 놀래요  ",
      ],
    },
    mov: {
      cn: "7fc874c71906c7fbb9163450bf8884bf_06",
      en: "d0ca04fdd48b1993c41d0ede4e4ee21a_06",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/orange/book6/images/img_O6-03.png"),
          sound: require("@data/assets/orange/book6/sounds/KB06_W_01.mp3"),
          word: "足球|zúqiú",
        },
        {
          img: require("@data/assets/orange/book6/images/img_O6-02.png"),
          sound: require("@data/assets/orange/book6/sounds/KB06_W_02.mp3"),
          word: "鼻子|bízi",
        },
        {
          img: require("@data/assets/orange/book6/images/img_O6-01.png"),
          sound: require("@data/assets/orange/book6/sounds/KB06_W_03.mp3"),
          word: "耳朵|ěrduo",
        },
        {
          img: require("@data/assets/orange/book6/images/img_O6-06.png"),
          sound: require("@data/assets/orange/book6/sounds/KB06_W_04.mp3"),
          word: "树|shù",
        },
        {
          img: require("@data/assets/orange/book6/images/img_O6-05.png"),
          sound: require("@data/assets/orange/book6/sounds/KB06_W_05.mp3"),
          word: "尾巴|wěiba",
        },
        {
          img: require("@data/assets/orange/book6/images/img_O6-04.png"),
          sound: require("@data/assets/orange/book6/sounds/KB06_W_06.mp3"),
          word: "屁股|pìgu",
        },
        {
          img: require("@data/assets/orange/book6/images/img_O6-08.png"),
          sound: require("@data/assets/orange/book6/sounds/KB06_W_07.mp3"),
          word: "很有意思!|Hěn yǒu yìsi!",
        },
        {
          img: require("@data/assets/orange/book6/images/img_O6-07.png"),
          sound: require("@data/assets/orange/book6/sounds/KB06_W_08.mp3"),
          word: "没有意思!|Méiyǒu yìsi!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/orange/book6/images/img_O6-03.png"),
        sound: require("@data/assets/orange/book6/sounds/KB06_W_01.mp3"),
        buttons: [{ ch2: "zúqiú" }, { ch: "足球" }, { ko: "축구" }],
      },
      {
        img: require("@data/assets/orange/book6/images/img_O6-02.png"),
        sound: require("@data/assets/orange/book6/sounds/KB06_W_02.mp3"),
        buttons: [{ ch2: "bízi" }, { ch: "鼻子" }, { ko: "코" }],
      },
      {
        img: require("@data/assets/orange/book6/images/img_O6-01.png"),
        sound: require("@data/assets/orange/book6/sounds/KB06_W_03.mp3"),
        buttons: [{ ch2: "ěrduo" }, { ch: "耳朵" }, { ko: "귀" }],
      },
      {
        img: require("@data/assets/orange/book6/images/img_O6-06.png"),
        sound: require("@data/assets/orange/book6/sounds/KB06_W_04.mp3"),
        buttons: [{ ch2: "shù" }, { ch: "树" }, { ko: "나무" }],
      },
      {
        img: require("@data/assets/orange/book6/images/img_O6-05.png"),
        sound: require("@data/assets/orange/book6/sounds/KB06_W_05.mp3"),
        buttons: [{ ch2: "wěiba" }, { ch: "尾巴" }, { ko: "꼬리" }],
      },
      {
        img: require("@data/assets/orange/book6/images/img_O6-04.png"),
        sound: require("@data/assets/orange/book6/sounds/KB06_W_06.mp3"),
        buttons: [{ ch2: "pìgu" }, { ch: "屁股" }, { ko: "엉덩이" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/orange/book6/images/img_O6-08.png"),
        sound: require("@data/assets/orange/book6/sounds/KB06_W_07.mp3"),
        buttons: [
          { ch2: "Hěn yǒu yìsi!" },
          { ch: "很有意思!" },
          { ko: "재미있어!" },
        ],
      },
      {
        img: require("@data/assets/orange/book6/images/img_O6-07.png"),
        sound: require("@data/assets/orange/book6/sounds/KB06_W_08.mp3"),
        buttons: [
          { ch2: "Méiyǒu yìsi!" },
          { ch: "没有意思!" },
          { ko: "재미없어!" },
        ],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/orange/book6/sounds/KB06_W_01.mp3"),
          img: require("@data/assets/orange/book6/images/img_O6-03.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/orange/book6/sounds/KB06_W_03.mp3"),
          answer: [
            [require("@data/assets/orange/book6/images/img_O6-02.png"), false],
            [require("@data/assets/orange/book6/images/img_O6-01.png"), true],
          ],
        },
        {
          type: "ty2",
          sound: require("@data/assets/orange/book6/sounds/KB06_W_05.mp3"),
          answer: [
            [require("@data/assets/orange/book6/images/img_O6-05.png"), true],
            [require("@data/assets/orange/book6/images/img_O6-06.png"), false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/orange/book6/pages/front.jpg"),
        sound: require("@data/assets/orange/book6/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/orange/book6/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page04.jpg"),
        sound: require("@data/assets/orange/book6/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page06.jpg"),
        sound: require("@data/assets/orange/book6/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page08.jpg"),
        sound: require("@data/assets/orange/book6/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page10.jpg"),
        sound: require("@data/assets/orange/book6/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page12.jpg"),
        sound: require("@data/assets/orange/book6/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page14.jpg"),
        sound: require("@data/assets/orange/book6/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page16.jpg"),
        sound: require("@data/assets/orange/book6/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page18.jpg"),
        sound: require("@data/assets/orange/book6/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page20.jpg"),
        sound: require("@data/assets/orange/book6/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page22.jpg"),
        sound: require("@data/assets/orange/book6/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page23.jpg"),
        sound: require("@data/assets/orange/book6/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/orange/book6/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/orange/book6/thumbnail/front.jpg"),
      require("@data/assets/orange/book6/thumbnail/page02.jpg"),
      require("@data/assets/orange/book6/thumbnail/page03.jpg"),
      require("@data/assets/orange/book6/thumbnail/page04.jpg"),
      require("@data/assets/orange/book6/thumbnail/page05.jpg"),
      require("@data/assets/orange/book6/thumbnail/page06.jpg"),
      require("@data/assets/orange/book6/thumbnail/page07.jpg"),
      require("@data/assets/orange/book6/thumbnail/page08.jpg"),
      require("@data/assets/orange/book6/thumbnail/page09.jpg"),
      require("@data/assets/orange/book6/thumbnail/page10.jpg"),
      require("@data/assets/orange/book6/thumbnail/page11.jpg"),
      require("@data/assets/orange/book6/thumbnail/page12.jpg"),
      require("@data/assets/orange/book6/thumbnail/page13.jpg"),
      require("@data/assets/orange/book6/thumbnail/page14.jpg"),
      require("@data/assets/orange/book6/thumbnail/page15.jpg"),
      require("@data/assets/orange/book6/thumbnail/page16.jpg"),
      require("@data/assets/orange/book6/thumbnail/page17.jpg"),
      require("@data/assets/orange/book6/thumbnail/page18.jpg"),
      require("@data/assets/orange/book6/thumbnail/page19.jpg"),
      require("@data/assets/orange/book6/thumbnail/page20.jpg"),
      require("@data/assets/orange/book6/thumbnail/page21.jpg"),
      require("@data/assets/orange/book6/thumbnail/page22.jpg"),
      require("@data/assets/orange/book6/thumbnail/page23.jpg"),
      require("@data/assets/orange/book6/thumbnail/page24.jpg"),
      require("@data/assets/orange/book6/thumbnail/page25.jpg"),
      require("@data/assets/orange/book6/thumbnail/page26.jpg"),
      require("@data/assets/orange/book6/thumbnail/page27.jpg"),
    ],
  },
  //7
  {
    key: "c2-07",
    title: "꼭꼭 숨어요",
    grade: "7권",
    cover: require("@data/assets/orange/book7/images/cover.jpg"),
    background: require("@data/assets/orange/book7/pages/page05.jpg"),
    song: {
      url: require("@data/assets/orange/book7/sounds/page23.mp3"),
      title: "Kuài diǎnr!",
      caption: [
        "똑딱똑딱 째깍째깍 약속 시간 늦겠어 빨리",
        "서둘러 kuài diǎnr 빨리 서둘러 kuài diǎnr",
        "미안 미안 친구들아 기다려줘 잠깐만 기다려",
        "děng yíxià  잠깐만 기다려  děng yíxià",
        "부릉부릉 부르르릉 버스가 곧 출발해",
        "서둘러 kuài diǎnr 빨리 서둘러 kuài diǎnr",
        "미안 미안 친구들아 기다려줘 잠깐만 기다려",
        "děng yíxià 잠깐만 기다려  děng yíxià",
      ],
    },
    mov: {
      cn: "8362331d1cb4b229d1f72f782800f0cb_07",
      en: "0d7d58bc41e41b1d3663d978a0842091_07",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/orange/book7/images/img_O7-03.png"),
          sound: require("@data/assets/orange/book7/sounds/KB07_W_01.mp3"),
          word: "彩虹|cǎihóng",
        },
        {
          img: require("@data/assets/orange/book7/images/img_O7-02.png"),
          sound: require("@data/assets/orange/book7/sounds/KB07_W_02.mp3"),
          word: "蛇|shé",
        },
        {
          img: require("@data/assets/orange/book7/images/img_O7-01.png"),
          sound: require("@data/assets/orange/book7/sounds/KB07_W_03.mp3"),
          word: "乌龟|wūguī",
        },
        {
          img: require("@data/assets/orange/book7/images/img_O7-06.png"),
          sound: require("@data/assets/orange/book7/sounds/KB07_W_04.mp3"),
          word: "眼睛|yǎnjing",
        },
        {
          img: require("@data/assets/orange/book7/images/img_O7-05.png"),
          sound: require("@data/assets/orange/book7/sounds/KB07_W_05.mp3"),
          word: "变色龙|biànsèlóng",
        },
        {
          img: require("@data/assets/orange/book7/images/img_O7-04.png"),
          sound: require("@data/assets/orange/book7/sounds/KB07_W_06.mp3"),
          word: "臭鼬|chòuyòu",
        },
        {
          img: require("@data/assets/orange/book7/images/img_O7-08.png"),
          sound: require("@data/assets/orange/book7/sounds/KB07_W_07.mp3"),
          word: "快点儿!|Kuài diǎnr!",
        },
        {
          img: require("@data/assets/orange/book7/images/img_O7-07.png"),
          sound: require("@data/assets/orange/book7/sounds/KB07_W_08.mp3"),
          word: "等一下!|Děng yíxià!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/orange/book7/images/img_O7-03.png"),
        sound: require("@data/assets/orange/book7/sounds/KB07_W_01.mp3"),
        buttons: [{ ch2: "cǎihóng" }, { ch: "彩虹" }, { ko: "무지개" }],
      },
      {
        img: require("@data/assets/orange/book7/images/img_O7-02.png"),
        sound: require("@data/assets/orange/book7/sounds/KB07_W_02.mp3"),
        buttons: [{ ch2: "shé" }, { ch: "蛇" }, { ko: "뱀" }],
      },
      {
        img: require("@data/assets/orange/book7/images/img_O7-01.png"),
        sound: require("@data/assets/orange/book7/sounds/KB07_W_03.mp3"),
        buttons: [{ ch2: "wūguī" }, { ch: "乌龟" }, { ko: "거북이" }],
      },
      {
        img: require("@data/assets/orange/book7/images/img_O7-06.png"),
        sound: require("@data/assets/orange/book7/sounds/KB07_W_04.mp3"),
        buttons: [{ ch2: "yǎnjing" }, { ch: "眼睛" }, { ko: "눈" }],
      },
      {
        img: require("@data/assets/orange/book7/images/img_O7-05.png"),
        sound: require("@data/assets/orange/book7/sounds/KB07_W_05.mp3"),
        buttons: [{ ch2: "biànsèlóng" }, { ch: "变色龙" }, { ko: "카멜레온" }],
      },
      {
        img: require("@data/assets/orange/book7/images/img_O7-04.png"),
        sound: require("@data/assets/orange/book7/sounds/KB07_W_06.mp3"),
        buttons: [{ ch2: "chòuyòu" }, { ch: "臭鼬" }, { ko: "스컹크" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/orange/book7/images/img_O7-08.png"),
        sound: require("@data/assets/orange/book7/sounds/KB07_W_07.mp3"),
        buttons: [{ ch2: "Kuài diǎnr!" }, { ch: "快点儿!" }, { ko: "빨리!" }],
      },
      {
        img: require("@data/assets/orange/book7/images/img_O7-07.png"),
        sound: require("@data/assets/orange/book7/sounds/KB07_W_08.mp3"),
        buttons: [{ ch2: "Děng yíxià!" }, { ch: "等一下!" }, { ko: "기다려!" }],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/orange/book7/sounds/KB07_W_02.mp3"),
          img: require("@data/assets/orange/book7/images/img_O7-02.png"),
          answer: {
            O: true,
            X: false,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/orange/book7/sounds/KB07_W_01.mp3"),
          answer: [
            [require("@data/assets/orange/book7/images/img_O7-03.png"), true],
            [require("@data/assets/orange/book7/images/img_O7-05.png"), false],
          ],
        },
        {
          type: "ty2",
          sound: require("@data/assets/orange/book7/sounds/KB07_W_04.mp3"),
          answer: [
            [require("@data/assets/orange/book7/images/img_O7-06.png"), true],
            [require("@data/assets/orange/book7/images/img_O7-04.png"), false],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/orange/book7/pages/front.jpg"),
        sound: require("@data/assets/orange/book7/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/orange/book7/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page04.jpg"),
        sound: require("@data/assets/orange/book7/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page06.jpg"),
        sound: require("@data/assets/orange/book7/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page08.jpg"),
        sound: require("@data/assets/orange/book7/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page10.jpg"),
        sound: require("@data/assets/orange/book7/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page12.jpg"),
        sound: require("@data/assets/orange/book7/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page14.jpg"),
        sound: require("@data/assets/orange/book7/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page16.jpg"),
        sound: require("@data/assets/orange/book7/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page18.jpg"),
        sound: require("@data/assets/orange/book7/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page20.jpg"),
        sound: require("@data/assets/orange/book7/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page22.jpg"),
        sound: require("@data/assets/orange/book7/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page23.jpg"),
        sound: require("@data/assets/orange/book7/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/orange/book7/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/orange/book7/thumbnail/front.jpg"),
      require("@data/assets/orange/book7/thumbnail/page02.jpg"),
      require("@data/assets/orange/book7/thumbnail/page03.jpg"),
      require("@data/assets/orange/book7/thumbnail/page04.jpg"),
      require("@data/assets/orange/book7/thumbnail/page05.jpg"),
      require("@data/assets/orange/book7/thumbnail/page06.jpg"),
      require("@data/assets/orange/book7/thumbnail/page07.jpg"),
      require("@data/assets/orange/book7/thumbnail/page08.jpg"),
      require("@data/assets/orange/book7/thumbnail/page09.jpg"),
      require("@data/assets/orange/book7/thumbnail/page10.jpg"),
      require("@data/assets/orange/book7/thumbnail/page11.jpg"),
      require("@data/assets/orange/book7/thumbnail/page12.jpg"),
      require("@data/assets/orange/book7/thumbnail/page13.jpg"),
      require("@data/assets/orange/book7/thumbnail/page14.jpg"),
      require("@data/assets/orange/book7/thumbnail/page15.jpg"),
      require("@data/assets/orange/book7/thumbnail/page16.jpg"),
      require("@data/assets/orange/book7/thumbnail/page17.jpg"),
      require("@data/assets/orange/book7/thumbnail/page18.jpg"),
      require("@data/assets/orange/book7/thumbnail/page19.jpg"),
      require("@data/assets/orange/book7/thumbnail/page20.jpg"),
      require("@data/assets/orange/book7/thumbnail/page21.jpg"),
      require("@data/assets/orange/book7/thumbnail/page22.jpg"),
      require("@data/assets/orange/book7/thumbnail/page23.jpg"),
      require("@data/assets/orange/book7/thumbnail/page24.jpg"),
      require("@data/assets/orange/book7/thumbnail/page25.jpg"),
      require("@data/assets/orange/book7/thumbnail/page26.jpg"),
      require("@data/assets/orange/book7/thumbnail/page27.jpg"),
    ],
  },
  //8
  {
    key: "c2-08",
    title: "넌 할 수 있어!",
    grade: "8권",
    cover: require("@data/assets/orange/book8/images/cover.jpg"),
    background: require("@data/assets/orange/book8/pages/page05.jpg"),
    song: {
      url: require("@data/assets/orange/book8/sounds/page23.mp3"),
      title: "Jiāyóu!",
      caption: [
        "너도나도 으샤으샤 다같이 으샤으샤",
        "힘내 jiāyóu  힘내  jiāyóu",
        "땀방울이 송글 송글 이마에 송글송글",
        "힘내 jiāyóu 힘내 jiāyóu",
        "너도나도 으샤으샤 다같이 으샤으샤",
        "잘했어 zhēn bàng 잘했어 zhēn bàng",
        "미소가 방긋방긋 환하게 방긋방긋",
        "잘했어 zhēn bàng 잘했어 zhēn bàng",
      ],
    },
    mov: {
      cn: "002ac962b1b6e4c58bbfd12124509685_08",
      en: "9f740ace4f9f75a9f364172eb2f2da9e_08",
    },
    game: {
      resources: [
        {
          img: require("@data/assets/orange/book8/images/img_O8-03.png"),
          sound: require("@data/assets/orange/book8/sounds/KB08_W_01.mp3"),
          word: "老鼠|lǎoshǔ",
        },
        {
          img: require("@data/assets/orange/book8/images/img_O8-02.png"),
          sound: require("@data/assets/orange/book8/sounds/KB08_W_02.mp3"),
          word: "鸭子|yāzi",
        },
        {
          img: require("@data/assets/orange/book8/images/img_O8-01.png"),
          sound: require("@data/assets/orange/book8/sounds/KB08_W_03.mp3"),
          word: "鹰|yīng",
        },
        {
          img: require("@data/assets/orange/book8/images/img_O8-06.png"),
          sound: require("@data/assets/orange/book8/sounds/KB08_W_04.mp3"),
          word: "船|chuán",
        },
        {
          img: require("@data/assets/orange/book8/images/img_O8-05.png"),
          sound: require("@data/assets/orange/book8/sounds/KB08_W_05.mp3"),
          word: "桥|qiáo",
        },
        {
          img: require("@data/assets/orange/book8/images/img_O8-04.png"),
          sound: require("@data/assets/orange/book8/sounds/KB08_W_06.mp3"),
          word: "狮子|shīzi",
        },
        {
          img: require("@data/assets/orange/book8/images/img_O8-08.png"),
          sound: require("@data/assets/orange/book8/sounds/KB08_W_07.mp3"),
          word: "加油!|Jiāyóu!",
        },
        {
          img: require("@data/assets/orange/book8/images/img_O8-07.png"),
          sound: require("@data/assets/orange/book8/sounds/KB08_W_08.mp3"),
          word: "真棒!|Zhēn bàng!",
        },
      ],
    },
    word: [
      {
        img: require("@data/assets/orange/book8/images/img_O8-03.png"),
        sound: require("@data/assets/orange/book8/sounds/KB08_W_01.mp3"),
        buttons: [{ ch2: "lǎoshǔ" }, { ch: "老鼠" }, { ko: "생쥐" }],
      },
      {
        img: require("@data/assets/orange/book8/images/img_O8-02.png"),
        sound: require("@data/assets/orange/book8/sounds/KB08_W_02.mp3"),
        buttons: [{ ch2: "yāzi" }, { ch: "鸭子" }, { ko: "오리" }],
      },
      {
        img: require("@data/assets/orange/book8/images/img_O8-01.png"),
        sound: require("@data/assets/orange/book8/sounds/KB08_W_03.mp3"),
        buttons: [{ ch2: "yīng" }, { ch: "鹰" }, { ko: "매" }],
      },
      {
        img: require("@data/assets/orange/book8/images/img_O8-06.png"),
        sound: require("@data/assets/orange/book8/sounds/KB08_W_04.mp3"),
        buttons: [{ ch2: "chuán" }, { ch: "船" }, { ko: "배" }],
      },
      {
        img: require("@data/assets/orange/book8/images/img_O8-05.png"),
        sound: require("@data/assets/orange/book8/sounds/KB08_W_05.mp3"),
        buttons: [{ ch2: "qiáo" }, { ch: "桥" }, { ko: "다리" }],
      },
      {
        img: require("@data/assets/orange/book8/images/img_O8-04.png"),
        sound: require("@data/assets/orange/book8/sounds/KB08_W_06.mp3"),
        buttons: [{ ch2: "shīzi" }, { ch: "狮子" }, { ko: "사자" }],
      },
    ],
    idiom: [
      {
        img: require("@data/assets/orange/book8/images/img_O8-08.png"),
        sound: require("@data/assets/orange/book8/sounds/KB08_W_07.mp3"),
        buttons: [{ ch2: "Jiāyóu!" }, { ch: "加油!" }, { ko: "파이팅!" }],
      },
      {
        img: require("@data/assets/orange/book8/images/img_O8-07.png"),
        sound: require("@data/assets/orange/book8/sounds/KB08_W_08.mp3"),
        buttons: [{ ch2: "Zhēn bàng!" }, { ch: "真棒!" }, { ko: "멋져!" }],
      },
    ],
    activity: {
      questions: [
        {
          type: "ty1",
          sound: require("@data/assets/orange/book8/sounds/KB08_W_01.mp3"),
          img: require("@data/assets/orange/book8/images/img_O8-02.png"),
          answer: {
            O: false,
            X: true,
          },
        },
        {
          type: "ty2",
          sound: require("@data/assets/orange/book8/sounds/KB08_W_04.mp3"),
          answer: [
            [require("@data/assets/orange/book8/images/img_O8-06.png"), true],
            [require("@data/assets/orange/book8/images/img_O8-05.png"), false],
          ],
        },
        {
          type: "ty2",
          sound: require("@data/assets/orange/book8/sounds/KB08_W_06.mp3"),
          answer: [
            [require("@data/assets/orange/book8/images/img_O8-01.png"), false],
            [require("@data/assets/orange/book8/images/img_O8-04.png"), true],
          ],
        },
      ],
    },
    pages: [
      {
        book: require("@data/assets/orange/book8/pages/front.jpg"),
        sound: require("@data/assets/orange/book8/sounds/cover.mp3"),
      },

      {
        book: require("@data/assets/orange/book8/pages/page02.jpg"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page03.jpg"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page04.jpg"),
        sound: require("@data/assets/orange/book8/sounds/page04.mp3"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page05.jpg"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page06.jpg"),
        sound: require("@data/assets/orange/book8/sounds/page06.mp3"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page07.jpg"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page08.jpg"),
        sound: require("@data/assets/orange/book8/sounds/page08.mp3"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page09.jpg"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page10.jpg"),
        sound: require("@data/assets/orange/book8/sounds/page10.mp3"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page11.jpg"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page12.jpg"),
        sound: require("@data/assets/orange/book8/sounds/page12.mp3"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page13.jpg"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page14.jpg"),
        sound: require("@data/assets/orange/book8/sounds/page14.mp3"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page15.jpg"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page16.jpg"),
        sound: require("@data/assets/orange/book8/sounds/page16.mp3"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page17.jpg"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page18.jpg"),
        sound: require("@data/assets/orange/book8/sounds/page18.mp3"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page19.jpg"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page20.jpg"),
        sound: require("@data/assets/orange/book8/sounds/page20.mp3"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page21.jpg"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page22.jpg"),
        sound: require("@data/assets/orange/book8/sounds/page22.mp3"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page23.jpg"),
        sound: require("@data/assets/orange/book8/sounds/page23.mp3"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page24.jpg"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page25.jpg"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page26.jpg"),
      },
      {
        book: require("@data/assets/orange/book8/pages/page27.jpg"),
      },
    ],
    thumbnail: [
      require("@data/assets/orange/book8/thumbnail/front.jpg"),
      require("@data/assets/orange/book8/thumbnail/page02.jpg"),
      require("@data/assets/orange/book8/thumbnail/page03.jpg"),
      require("@data/assets/orange/book8/thumbnail/page04.jpg"),
      require("@data/assets/orange/book8/thumbnail/page05.jpg"),
      require("@data/assets/orange/book8/thumbnail/page06.jpg"),
      require("@data/assets/orange/book8/thumbnail/page07.jpg"),
      require("@data/assets/orange/book8/thumbnail/page08.jpg"),
      require("@data/assets/orange/book8/thumbnail/page09.jpg"),
      require("@data/assets/orange/book8/thumbnail/page10.jpg"),
      require("@data/assets/orange/book8/thumbnail/page11.jpg"),
      require("@data/assets/orange/book8/thumbnail/page12.jpg"),
      require("@data/assets/orange/book8/thumbnail/page13.jpg"),
      require("@data/assets/orange/book8/thumbnail/page14.jpg"),
      require("@data/assets/orange/book8/thumbnail/page15.jpg"),
      require("@data/assets/orange/book8/thumbnail/page16.jpg"),
      require("@data/assets/orange/book8/thumbnail/page17.jpg"),
      require("@data/assets/orange/book8/thumbnail/page18.jpg"),
      require("@data/assets/orange/book8/thumbnail/page19.jpg"),
      require("@data/assets/orange/book8/thumbnail/page20.jpg"),
      require("@data/assets/orange/book8/thumbnail/page21.jpg"),
      require("@data/assets/orange/book8/thumbnail/page22.jpg"),
      require("@data/assets/orange/book8/thumbnail/page23.jpg"),
      require("@data/assets/orange/book8/thumbnail/page24.jpg"),
      require("@data/assets/orange/book8/thumbnail/page25.jpg"),
      require("@data/assets/orange/book8/thumbnail/page26.jpg"),
      require("@data/assets/orange/book8/thumbnail/page27.jpg"),
    ],
  },
];
